module.exports = __webpack_public_path__ + "img/vpc5.2f1cfe1.png";